import React from 'react';
import { Inbox, Plus } from 'lucide-react';

export function EmptyState({ icon: Icon = Inbox, title, message, actionLabel, onAction, testId }) {
    return (
        <div className="py-12 px-6 text-center bg-white border border-gray-200 rounded-xl" data-testid={testId || 'empty-state'}>
            <div className="mx-auto h-12 w-12 rounded-full bg-aks-gold-soft flex items-center justify-center text-aks-navy mb-3"><Icon className="h-5 w-5" /></div>
            <div className="text-[15px] font-bold text-aks-text">{title}</div>
            {message && <div className="text-[12px] text-gray-500 mt-1 max-w-sm mx-auto">{message}</div>}
            {actionLabel && onAction && (
                <button onClick={onAction} className="mt-4 h-10 px-4 inline-flex items-center gap-1.5 rounded-md bg-aks-gold text-aks-navy font-semibold text-[13px]">
                    <Plus className="h-4 w-4" /> {actionLabel}
                </button>
            )}
        </div>
    );
}

export function Skeleton({ className = '' }) {
    return <div className={`aks-skeleton ${className}`} />;
}

export function CardSkeleton() {
    return (
        <div className="bg-white border border-gray-200 rounded-xl p-4 space-y-3">
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="h-3 w-1/2" />
            <div className="grid grid-cols-2 gap-2"><Skeleton className="h-3" /><Skeleton className="h-3" /></div>
            <Skeleton className="h-9 w-full" />
        </div>
    );
}

export function CardGridSkeleton({ count = 6 }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {Array.from({ length: count }).map((_, i) => <CardSkeleton key={i} />)}
        </div>
    );
}
